import axios from "axios";
import { useState } from "react";
import DetailCommandeMagasin from "../../Views/Magasin/historique/DetailCommandeMagasin";

export default function ConfirmerCommandeMagasin(){
    const [MessageSucess, setMessageSucess] = useState<string>("");
    const [MessageError,  setMessageError]  = useState<string>("");
    const [stockInfo, setStockInfo]         = useState<{ref: string; nomMagasin: string; newQte: number}[]>([]);

const handleSubmitUpdate = async (
  ref: string,
  nommagasin: string,
  qte: number,
  id: number,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/confirme/magasin/${id}/${nommagasin}`,
      { qte, id }
    );

    // Show updated stock quantities returned by the API
    const updatedArticles: any[] = response.data?.updated_articles ?? [];
    if (updatedArticles.length > 0) {
      setStockInfo(
        updatedArticles.map((a: any) => ({
          ref: a.RefArticle,
          nomMagasin: a.NomMagasin,
          newQte: a.Qte,
        }))
      );
      setTimeout(() => setStockInfo([]), 6000);
    }

    setMessageSucess(response.data?.message ?? "Commande confirmée et stock mis à jour.");
    setTimeout(() => setMessageSucess(''), 4000);
    return true;

  } catch (error: any) {
    const msg =
      error?.response?.data?.message ?? "Une erreur est survenue lors de la confirmation.";
    setMessageError(msg);
    setTimeout(() => setMessageError(''), 4000);
    return false;
  }
};

const handleAnnuleCommande = async (id: number) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/annule/${id}`
    );
    setMessageSucess(response.data?.message ?? "Commande annulée.");
    setTimeout(() => setMessageSucess(''), 3000);
    return true;
  } catch (error) {
    setMessageError("Une erreur est survenue.");
    setTimeout(() => setMessageError(''), 3000);
    return false;
  }
};

  return (
    <>
      {/* Stock update banner */}
      {stockInfo.length > 0 && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 99999,
          background: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)',
          color: '#fff',
          borderRadius: '14px',
          padding: '16px 20px',
          boxShadow: '0 8px 32px rgba(11,163,96,0.35)',
          minWidth: '260px',
          maxWidth: '340px',
          animation: 'slideInRight 0.4s cubic-bezier(0.4,0,0.2,1)',
        }}>
          <style>{`
            @keyframes slideInRight {
              from { opacity: 0; transform: translateX(40px); }
              to   { opacity: 1; transform: translateX(0); }
            }
          `}</style>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
            <span style={{ fontSize: '20px' }}>📦</span>
            <strong style={{ fontSize: '15px' }}>Stock mis à jour</strong>
          </div>
          {stockInfo.map((item, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,0.18)',
              borderRadius: '8px',
              padding: '8px 12px',
              marginBottom: i < stockInfo.length - 1 ? '6px' : 0,
              fontSize: '13px',
            }}>
              <div style={{ fontWeight: 600 }}>{item.ref}</div>
              <div style={{ opacity: 0.9, marginTop: '2px' }}>
                {item.nomMagasin} — Nouveau stock : <strong>{item.newQte}</strong> unité{item.newQte !== 1 ? 's' : ''}
              </div>
            </div>
          ))}
        </div>
      )}

      <DetailCommandeMagasin
        MessageSucess={MessageSucess}
        MessageError={MessageError}
        handleSubmitUpdate={handleSubmitUpdate}
        handleAnnuleCommande={handleAnnuleCommande}
      />
    </>
  );
}
